import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

const readCookie = (name) =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1];

/** Content preview: while `?preview=1` is in the URL every request carries it, so QA browses the
 *  real customer screens. The server ignores it unless the caller is an authorized operator. */
export const previewParams = () => {
  const q = new URLSearchParams(window.location.search);
  if (q.get("preview") !== "1") return {};
  const tier = q.get("tier");
  return { preview: "1", ...(tier ? { tier } : {}) };
};

export const isPreview = () => !!previewParams().preview;

const withPreview = (path) => {
  const params = new URLSearchParams(previewParams()).toString();
  if (!params) return path;
  return `${path}${path.includes("?") ? "&" : "?"}${params}`;
};

/** Double-submit CSRF: echo the readable csrf cookie back on state-changing calls. */
api.interceptors.request.use((config) => {
  if (["post", "put", "patch", "delete"].includes(config.method?.toLowerCase())) {
    const token = readCookie("ppcp_csrf");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  config.params = { ...previewParams(), ...(config.params ?? {}) };
  return config;
});

export const routes = {
  library: withPreview("/library"),
  program: (slug) => withPreview(`/p/${slug}`),
  intro: (slug, page) => withPreview(`/p/${slug}/intro/${page}`),
  days: (slug) => withPreview(`/p/${slug}/days`),
  day: (slug, n) => withPreview(`/p/${slug}/day/${n}`),
  week: (slug, w) => withPreview(`/p/${slug}/week/${w}`),
  guide: (slug, key, day) => withPreview(`/p/${slug}/guide/${key}${day ? `?day=${day}` : ""}`),
  completion: (slug) => withPreview(`/p/${slug}/complete`),
  profile: withPreview("/profile"),
};

export const SLOT_LABELS = {
  breakfast: "Breakfast",
  mid_morning: "Mid-Morning",
  lunch: "Lunch",
  snack: "Snack",
  evening_snack: "Evening Snack",
  dinner: "Dinner",
  bedtime: "Bedtime",
  tiffin: "Today's Tiffin",
};

export const SLOT_ORDER = Object.keys(SLOT_LABELS);

export const sortSlots = (meals = []) =>
  [...meals].sort((a, b) => SLOT_ORDER.indexOf(a.slot) - SLOT_ORDER.indexOf(b.slot));

/** Single seam for analytics — now backed by GA4. */
export { track } from "@/lib/analytics";
